module.exports = __webpack_public_path__ + "img/06_no.a6c38062.svg";